module.exports = "//docs.gtimg.com/slide/img/img/closed-2x-7a72ec.png";